
import $ from 'jquery';

export function TextAutoplay() {
    setInterval(function(){
        advance($('.autoplayTexts'));
      }, 5000);
      
      function advance(autoplayTexts){
        $('.done', autoplayTexts).removeClass('done');
        $('.leaving', autoplayTexts).removeClass('leaving').addClass('done');
        $('.active', autoplayTexts).removeClass('active').addClass('leaving');
        if( $('.leaving + .autoplayText').length === 1){
          $('.leaving + .autoplayText', autoplayTexts).addClass('active');
        }else{
            autoplayTexts.children().eq(0).addClass('active');
        }
      }
      
      $(document).ready(function () {
        $('#nav-toggle').click(function () {
             if ($(this).hasClass('open')) {
                  $(this).removeClass('open');
                  $('nav.mobile').removeClass('mobile--open');
             } else {
                  $(this).addClass('open');
                  $('nav.mobile').addClass('mobile--open');
             }
        });
   });
      
      
}